import React from "react";
import usePageMeta from "../hooks/usePageMeta";
import { Link } from "react-router-dom";
import { PRODUCT_CATEGORIES } from "../content";

export default function Products() {
  usePageMeta({
    title: "Custom Furniture Dubai | Bespoke Furniture Collections — Time Furniture",
    description: "Explore custom furniture from Time Furniture in Dubai and the UAE. Choose materials, finishes and dimensions for bespoke pieces made to your brief.",
    canonical: "https://timefurniture.ae/products",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "Custom Furniture Collections",
      url: "https://timefurniture.ae/products",
      description: "Customisable furniture with a choice of materials, finishes, dimensions and details.",
    },
  });

  return (
    <div data-testid="products-page" className="bg-[#FAF5EC]">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 pt-12 md:pt-16 pb-16">
        <p className="eyebrow mb-6">Products · 100% Customisable</p>
        <h1 className="font-serif-display text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight max-w-5xl">
          Pieces, made to <em className="text-[#6E1F2C] not-italic">your brief</em>.
        </h1>
        <p className="mt-8 max-w-2xl text-[#7A6B5F] leading-relaxed">
          Every product is fully customisable — materials, finishes, dimensions, and details. Browse categories and request a tailored quote from our team.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 pb-24 md:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PRODUCT_CATEGORIES.map((c, i) => (
            <article
              key={c.key}
              data-testid={`product-card-${c.key}`}
              className="group overflow-hidden animate-fade-up"
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              <div className="overflow-hidden h-80 relative">
                <img loading="lazy" src={c.image} alt={c.title} className="w-full h-full object-cover img-zoom" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors" />
                <div className="absolute top-5 left-5 text-[10px] tracking-[0.28em] uppercase text-[#6E1F2C]">
                  Collection
                </div>
              </div>
              <div className="pt-5 flex items-end justify-between gap-4">
                <div>
                  <p className="font-serif-display text-2xl md:text-3xl text-[#1C110C]">{c.title}</p>
                  <p className="mt-2 text-sm text-[#7A6B5F]">{c.blurb}</p>
                </div>
                <Link
                  to="/contact"
                  data-testid={`product-cta-${c.key}`}
                  className="shrink-0 text-[10px] tracking-[0.28em] uppercase text-[#6E1F2C] link-elegant"
                >
                  Enquire →
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="border-t border-[#6E1F2C]/15 py-28 md:py-40 lg:py-48 text-center">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <p className="eyebrow mb-5">Tailored Commissions</p>
          <h2 className="font-serif-display text-4xl md:text-6xl tracking-tight max-w-3xl mx-auto">
            Have a piece in mind? We'll build it.
          </h2>
          <Link
            to="/contact"
            data-testid="products-bottom-cta"
            className="mt-12 inline-flex items-center gap-3 bg-[#6E1F2C] text-[#FAF5EC] px-10 py-5 text-[11px] tracking-[0.28em] uppercase hover:bg-[#56151F] transition-colors"
          >
            Request Custom Quote
          </Link>
        </div>
      </section>
    </div>
  );
}
